import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Login from "./pages/Login";
import Register from "./pages/Register";
import LoanList from "./components/LoanList";
import ProtectedRoute from "./components/ProtectedRoute";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import NotFound from "./pages/404Page";
import "./App.css";
import "./styling/button.css";
function App() {
  const user = localStorage.getItem("user"); // get logged-in user

  return (
    <BrowserRouter>
      <Navbar />
      <div className="page-container">
        <Routes>
          {/* Default route: redirect to loanlist if logged in, else login */}
          <Route
            path="/"
            element={
              user ? <Navigate to="/loanlist" /> : <Navigate to="/login" />
            }
          />

          {/* Login route */}
          <Route
            path="/login"
            element={user ? <Navigate to="/loanlist" /> : <Login />}
          />

          {/* Register route (admin-only can handle inside Register page) */}
          <Route path="/register" element={<Register />} />

          {/* Protected loanlist route */}
          <Route
            path="/loanlist"
            element={
              <ProtectedRoute>
                <LoanList />
              </ProtectedRoute>
            }
          />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
